import useShowSuccess from 'hooks/useShowSuccess'
import { useCreatePartMutation, CreatePartMutationVariables } from '../../../../graphql'

export default function useCreatePartHandler() {
	const [ createPart ] = useCreatePartMutation( )
	const showSuccess = useShowSuccess()

	return async( { partNumber, providerId, description, upc, standardPrice, msrp, productClassId }: CreatePartMutationVariables ) => {
		await createPart( {
			variables: {
				partNumber,
				providerId,
				description,
				upc,
				standardPrice,
				msrp,
				productClassId,
			},
		} )
		showSuccess( `createPartSuccess${Date.now()}`, 'Successfully created product!' )
	}
}
